<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card color="green"
                            icon="mdi-content-copy"
                            title="Edit acive consignment stock"
                            class="px-5 py-3">
          <br />
          <v-text-field color="grey darken-1"
                        label="Status"
                        readonly
                        :value="consignmentStock.status | getStockStatusName"
                        prepend-icon="mdi-message"></v-text-field>
          <v-form class="mt-5" @submit.prevent="update">
            <v-text-field color="grey darken-1"
                          v-model="consignmentStock.customer.name"
                          label="Customer"
                          readonly
                          prepend-icon="mdi-account" />
            <v-row>
              <v-col cols="6">
                <v-menu v-model="startCalendar"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        disabled
                        color="grey darken-1">
                  <template v-slot:activator="{ on }">
                    <v-text-field color="grey darken-1"
                                  v-model="consignmentStock.start"
                                  label="Start"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  name="start date"
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="consignmentStock.start"></v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6">
                <v-menu v-model="endCalendar"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="consignmentStock.end"
                                  label="End"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="consignmentStock.end" @input="endCalendar = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-expand-transition>
              <v-list>
                <v-list-item v-for="(pq, i) in consignmentStock.items" :key="i">
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="4" class="noBottomTopPaddings">
                        <br />
                        <div v-if=" !pq.isCustom">
                          <v-list-item-subtitle>Product</v-list-item-subtitle>
                          <v-list-item-title v-text="pq.product.name + ' - ' + pq.product.articleNumber"></v-list-item-title>
                        </div>
                      </v-col>

                      <v-col cols="4" class="noBottomTopPaddings">
                        <v-text-field v-model="pq.quantity"
                                      type="number"
                                      label="Quantity"
                                      name="quantity"
                                      readonly
                                      disabled></v-text-field>
                      </v-col>
                      <v-col cols="4" class="noBottomTopPaddings">
                        <v-text-field v-model="pq.returnedQuantity"
                                      type="number"
                                      label="Returned quantity"
                                      name="returnedQuantity"
                                      @keypress="onlyInteger"
                                      data-vv-as="Returned quantity"
                                      v-validate="validators.returnedQuantity"
                                      :error="getError('returnedQuantity')"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expand-transition>
            <br />
            <v-row justify="center">
              <v-col cols="12" sm="2">
                <v-card-actions class="pl-0">
                  <v-btn color="info" min-width="100" @click="goBack()" width="100%">Return</v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" sm="2">
                <v-card-actions class="pl-0">
                  <v-btn
                    type="submit"
                    color="success"
                    min-width="100"
                    width="100%"
                    :disabled="buttonsDisabled"
                  >Save</v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" sm="2">
                <v-card-actions class="pl-0">
                  <v-btn
                    color="warning"
                    min-width="100"
                    width="100%"
                    @click="returnStockDialog = true"
                    :disabled="buttonsDisabled"
                  >Return stock</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
    <v-dialog v-model="returnStockDialog" persistent max-width="550">
      <v-card>
        <v-card-title class="headline">Return consignmnet stock</v-card-title>
        <v-card-text class="noBottomTopPaddings">
          <v-container>
            <v-row justify="center">
              <v-col>
                <v-text-field v-model="consignmentStock.discount"
                              label="Discount %"
                              name="discount"
                              :hint="errors.first('discount')"
                              @keypress="onlyDecimal"
                              data-vv-as="discount"
                              v-validate="'between:0,100'"
                              :error="getError('discount')"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="noBottomTopPaddings">
          <v-btn color="orange" text @click="returnStockDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="returnStock(true,0)">Return with invoice</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="returnStock(false,0)">Return with order</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="snackColor">
        {{ message }}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
  import router from "../../../router";
  import axios from "../../../utils/axios";
  import { onlyInteger, onlyDecimal } from "../../../helpers/inputHelper";
  import {
    getErrorMessageFromException,
    getErrorMessageFromValidation
  } from "../../../helpers/errorHelper";

  export default {
    name: "ConsignmentStocksActiveEdit",
    data: () => ({
      consignmentStock: {
        id: 0,
        errorMessage: String,
        totalValue: 0,
        totalInValue: 0,
        start: new Date().toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
        status: 0,
        discount: String,
        customer: {
          id: null,
          name: String
        },
        items: []
      },
      validators: {
        returnedQuantity: {
          required: true
        }
      },

      startCalendar: false,
      endCalendar: false,

      snackbar: false,
      message: "",
      snackColor: "error",

      buttonsDisabled: false,
      returnStockDialog: false,
      discountMessage: ""
    }),

    created() {
      this.getConsignmentStock();
    },
    methods: {
      async getConsignmentStock() {
        let loader = this.$loading.show();
        try {
          var result = await axios.get(
            "/ConsignmentStock/" + this.$route.params.id
          );
          if (result) {
            this.consignmentStock = result.data;
            this.consignmentStock.start = new Date(result.data.start)
              .toISOString()
              .substr(0, 10);
            this.consignmentStock.end = new Date(result.data.end)
              .toISOString()
              .substr(0, 10);

            if (this.consignmentStock.status !== 1) {
              //status 1 = active
              this.buttonsDisabled = true;
            }
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = getErrorMessageFromException(exception);
          this.snackColor = "error";
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },

      async returnStock(invoiceOnly) {
        this.returnStockDialog = false;
        this.$validator.validateAll().then(async isValid => {
          if (isValid) {
            let loader = this.$loading.show();
            try {
              for (let i = 0; i < this.consignmentStock.items.length; i++) {
                this.consignmentStock.items[i].quantity = parseInt(
                  this.consignmentStock.items[i].quantity
                );
                this.consignmentStock.items[i].returnedQuantity = parseInt(
                  this.consignmentStock.items[i].returnedQuantity
                );
              }
              this.consignmentStock.discount = parseFloat(
                this.consignmentStock.discount
              );
              var result = await axios.put(
                "/ConsignmentStock/ReturnConsignmentStock/?invoiceOnly=" +
                invoiceOnly,
                this.consignmentStock
              );

              if (result) {
                this.$router.go(-1);
              } else {
                throw "Unknown error";
              }
            } catch (exception) {
              this.buttonsDisabled = true;
              this.message = getErrorMessageFromException(exception);
              this.snackColor = "error";
              this.snackbar = true;

              setTimeout(() => this.goBack(), 2500);
            } finally {
              loader.hide();
            }
          } else {
            this.message = getErrorMessageFromValidation(this.errors.items);
            this.snackColor = "error";
            this.snackbar = true;
          }
        });
      },
      async update() {
        this.$validator.validateAll().then(async isValid => {
          if (isValid) {
            let loader = this.$loading.show();
            try {
              for (let i = 0; i < this.consignmentStock.items.length; i++) {
                this.consignmentStock.items[i].quantity = parseInt(
                  this.consignmentStock.items[i].quantity
                );

                this.consignmentStock.items[i].returnedQuantity = parseInt(
                  this.consignmentStock.items[i].returnedQuantity
                );
              }

              var result = await axios.put(
                "/ConsignmentStock",
                this.consignmentStock
              );
              if (result) {
                this.consignmentStock = result.data;
                this.consignmentStock.start = new Date(result.data.start)
                  .toISOString()
                  .substr(0, 10);
                this.consignmentStock.end = new Date(result.data.end)
                  .toISOString()
                  .substr(0, 10);

                this.snackColor = "success";
                this.message = "Success";
                this.snackbar = true;
              } else {
                throw "Unknown error";
              }
            } catch (exception) {
              this.message = getErrorMessageFromException(exception);

              this.snackColor = "error";
              this.snackbar = true;
            } finally {
              loader.hide();
            }
          } else {
            this.message = this.message = getErrorMessageFromValidation(
              this.errors.items
            );
            this.snackColor = "error";
            this.snackbar = true;
          }
        });
      },

      getError(fieldName) {
        if (this.errors.first(fieldName) !== undefined) {
          return true;
        }
        return false;
      },

      goBack() {
        this.$router.go(-1);
      },

      onlyInteger($event) {
        onlyInteger($event);
      },

      onlyDecimal($event) {
        onlyDecimal($event, this.consignmentStock.discount);
      },
      text: item => item.name + " — " + item.articleNumber
    }
  };
</script>

<style>
  .noBottomTopPaddings {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
</style>
